class SearchForm extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector('input[type="search"]');
    this.resetButton = this.querySelector('button[type="reset"]');

    if (this.input) {
      this.input.form.addEventListener("reset", this.onFormReset.bind(this));
      this.input.addEventListener(
        "input",
        debounce((event) => {
          this.onChange(event);
        }, 300).bind(this)
      );
    }
  }

  toggleResetButton() {
    const resetIsHidden = this.resetButton.classList.contains("hidden");
    if (this.input.value.length > 0 && resetIsHidden) {
      this.resetButton.classList.remove("hidden");
    } else if (this.input.value.length === 0 && !resetIsHidden) {
      this.resetButton.classList.add("hidden");
    }
  }

  onChange() {
    this.toggleResetButton();
  }

  shouldResetForm() {
    return !document.querySelector('[aria-selected="true"] a');
  }

  onFormReset(event) {
    // Prevent default so the form reset doesn't set the value gotten from the url on page load
    event.preventDefault();
    // Don't reset if the user has selected an element on the predictive search dropdown
    if (this.shouldResetForm()) {
      this.input.value = "";
      this.input.focus();
      this.toggleResetButton();
    }
  }
}

customElements.define("search-form", SearchForm);

// Function to inject a CSS link into the page
function loadCSS(href) {
  const link = document.createElement("link"); // Create a <link> element
  link.rel = "stylesheet"; // Specify it's a stylesheet
  link.href = href; // Set the href to the CSS file
  link.type = "text/css"; // Set the type
  link.media = "all"; // Ensure it applies to all media

  document.head.appendChild(link); // Append the link to the <head> of the document
}

// Usage example
loadCSS("https://prime-bite.myshopify.com/cdn/shop/t/1/assets/web-flow.css"); // Replace with your CSS file URL
